<div class="chat-response-group-container">
  <div class="chat-robot-icon-container" [class.chat-loader-icon-container]="!contentResponses.length">
    <mat-icon [svgIcon]="!contentResponses.length ? 'chat-loader' : 'chat-robot'"></mat-icon>
  </div>
  <div class="chat-response-group">
    <div class="chat-status-group">
      <button class="chat-status-toggle" type="button" [attr.aria-expanded]="isStatusExpanded"
        [class.chat-thinking]="!contentResponses.length" [class.chat-reasoning-complete]="contentResponses.length"
        (click)="statusResponses.length ? toggleStatusMessages() : null">
        <ng-container *ngIf="contentResponses.length">
          <div class="chat-check-icon-container">
            <mat-icon svgIcon="chat-check"></mat-icon>
          </div>
          <span>
            {{ 'CHAT_AI.REASONING_COMPLETE' | translate }}
            <ng-container *ngIf="statusResponses.length">
              ({{ statusResponses.length }} {{ 'CHAT_AI.STEPS' | translate }})
            </ng-container>
          </span>
        </ng-container>
        <ng-container *ngIf="!contentResponses.length">
          <div class="chat-brain-icon-container">
            <mat-icon svgIcon="chat-brain"></mat-icon>
          </div>
          <span>
            {{ 'CHAT_AI.THINKING' | translate }}
            <ng-container *ngIf="statusResponses.length">
              ({{ 'CHAT_AI.STEP' | translate }} {{ statusResponses.length }})
            </ng-container>
          </span>
        </ng-container>
        <span class="chat-status-indicator" *ngIf="statusResponses.length">
          <mat-icon svgIcon="chat-chevron-down" [class.chat-status-indicator-expanded]="isStatusExpanded"></mat-icon>
        </span>
      </button>

      <div class="chat-status-list" [class.chat-status-list-expanded]="isStatusExpanded && statusResponses.length"
        [attr.aria-hidden]="!isStatusExpanded || !statusResponses.length">
        <div class="chat-status-list-inner">
          <lib-chat-status-response-message *ngFor="let response of statusResponses let i = index" [response]="response"
            [rowIndex]="i">
          </lib-chat-status-response-message>
        </div>
      </div>
    </div>

    <ng-container *ngFor="let response of contentResponses" [ngSwitch]="response.type">
      <lib-chat-answer-response-message *ngSwitchCase="'answer'" [response]="asAnswerResponse(response)">
      </lib-chat-answer-response-message>

      <lib-chat-error-response-message *ngSwitchCase="'error'" [response]="asErrorResponse(response)">
      </lib-chat-error-response-message>

      <lib-chat-visualization-response-message *ngSwitchCase="'visualization'"
        [response]="asVisualizationResponse(response)">
      </lib-chat-visualization-response-message>
    </ng-container>
  </div>
</div>
